<!-- eslint-disable max-lines -->
<template>
    <Paper class="trafficTrajectory">
        <div class="trajectoryHead">
            <m-search-list
                ref="search"
                :searchId="searchId"
                :list="config.searchList"
                :searchTotalTitle="searchTotalTitle"
                :searchSetTitle="searchSetTitle"
                @onSearchChange="searchChange">
            </m-search-list>
        </div>
        <el-main v-loading="mianLoading">
            <div class="trajectoryContent">
                <div class="contenLeft">
                    <div class="contentTitle">
                        <div class="content"
                            :class="{ 'activeClass': currentIdx == 1}"
                            @click="contentTitleClick(1)">
                            <div class="lable">在途</div>
                            <span class="value">{{ontheway}}</span>
                        </div>
                        <div class="content"
                            :class="{ 'activeClass': currentIdx == 2}"
                            @click="contentTitleClick(2)">
                            <div class="lable">逾期</div>
                            <span class="value">{{overdue}}</span>
                        </div>
                    </div>
                    <div class="total" @scroll="handleScroll($event)">
                        <el-scrollbar>
                            <div
                                class="contentBottom"
                                :class="{'active':index===current,'notActive':!(index===current)}"
                                v-for="(item, index) in tabItems"
                                :key="index"
                                @click="tabClick(item, index)">
                                <div class="particulars">
                                    <div class="particularsLeft">
                                        <div class="licensePlate">
                                            <img class="licensePlateImg" :src="item.icon">
                                            <span class="licensePlateNum">{{item.vehicleCard}}</span>
                                        </div>
                                        <div class="percentage" :class="item.className">{{item.efficiency}}</div>
                                        <div class="loadingRate">{{item.rate}}</div>
                                    </div>
                                    <div class="particularsRight">
                                        <div class="leftLable">
                                            <span>发车单号：</span>
                                            <span class="leftValue">{{item.dispatchNo}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>发车时间：</span>
                                            <span :title='item.dispatchTime' class="leftValue leftCont">{{item.dispatchTime}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>司机：</span>
                                            <span :title='item.drive' class="leftValue leftCont">{{item.drive}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>司机电话：</span>
                                            <span class="leftValue">{{item.driverContactWay}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>总里程：</span>
                                            <span class="leftValue">{{item.totalMileage}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>最优路径：</span>
                                            <span :title='item.bestTour' class="leftValue">{{item.bestTour}}</span>
                                        </div>
                                        <div class="leftLable">
                                            <span>设备号：</span>
                                            <span class="leftValue">{{item.deviceNo}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
                <div id="contenRight">
                    <div :id="mapId" class="bmap" :style="{ height: '100%' }"></div>
                    <div v-if="isShow" class="map-event">
                        <div class="left-text-btn">
                            <el-dropdown @command="handleTrackClassify">
                                <span class="el-dropdown-link">
                                    轨迹类别({{trackClassifyName}})<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1">直通宝</el-dropdown-item>
                                    <el-dropdown-item command="2">微信</el-dropdown-item>
                                    <el-dropdown-item command="3">小黑卡</el-dropdown-item>
                                    <el-dropdown-item command="4">G7</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="btn-text left-text-btn" @click="handlePointList">定位点清单</div>
                        <div class="btn-text">
                            <el-dropdown  @command="handleSpeedClick">
                                <span class="el-dropdown-link">
                                  播放速度({{handleNum}})<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="5">快</el-dropdown-item>
                                    <el-dropdown-item command="3">正常</el-dropdown-item>
                                    <el-dropdown-item command="1">慢</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="car-center btn-text" @click="trackPlayback">轨迹回放</div>
                        <div class="btn-text" @click="trackBegin" v-show="+trackState === 0">轨迹播放</div>
                        <div class="btn-text" @click="trackStop" v-show="+trackState === 1">轨迹暂停</div>
                        <div class="btn-text" @click="trackBegin" v-show="+trackState === 2">轨迹继续</div>
                    </div>
                </div>
            </div>
        </el-main>
        <point-list v-if="isPointListShow" :isPointListShow.sync="isPointListShow"
            :currentItem="currentItem" @pointListClose="pointListClose"></point-list>
    </Paper>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import Paper from '@/components/core/paper/Paper';
import mSearchList from '@/components/otpPanel/mSearchList';
import config from './trafficTrajectory.json';
import { getTrafficLists, getTrajectoryLists, pointList } from '../../../api/trafficTrajectory';
import formatTime from '@/utils/common.js';
import { mapGetters } from 'vuex';
import { loadBMap } from './mapClass';
import loadMap from '../../../components/dialog/detailMap/loadBMap';
import PointList from './PointList';
export default {
    name: 'trafficTrajectory',
    components: { Paper, mSearchList, PointList },
    data() {
        return {
            polylinePath: [],
            currentIdx: 0,
            isShow: false,
            searchId: 'search_table1_query',
            searchList: config.searchList,
            config: config,
            searchTotalTitle: config.searchTotalTitle,
            searchSetTitle: config.searchTotalTitle,
            current: 'aa',
            tabItems: [],
            // 途径点
            points: [],
            tabOneArrs: [],
            tabTwoArrs: [],
            ontheway: 0,
            overdue: 0,
            trafficListsPage: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            },
            morePoints: [],
            cardMorePoints: [],
            baoMorePoints: [],
            g7MorePoints: [],
            weiMorePoints: [],
            polylinePoint: [],
            mianLoading: false,
            clickPointArr: [],
            clickPointArrPath: [],
            distance: '',
            pointsPlayback: [],
            polylinePlayback: [],
            mapId: 'BMap-' + parseInt(Date.now() + Math.random()),
            myMap: null,
            BMap: null,
            BMapLib: null,
            trackState: 0,
            handleNum: '正常',
            trackSpeed: 2000,
            isPointListShow: false,
            trackClassify: '',
            trackClassifyName: '',
            index: 0,
            lushu: null,
            currentItem: null,
            opts: {
                width: 250,
                height: 210,
                title: '定位点信息',
                enableMessage: true,
                enableAutoPan: false
            }
        };
    },
    computed: {
        ...mapGetters(['supplier'])
    },
    methods: {
        load(val, type) {
            if (!type) this.trafficListsPage.pageNo = 1;
            this.currentIdx = 0;
            this.current = '';
            this.isShow = false;
            const searchData = this.$refs.search.searchData;
            const params = {
                dispatchNo: searchData.dispatchNo,
                vehicleCard: searchData.vehicleCard,
                // dispatchStatus: 40,
                beginDate: searchData.dispatchTime ? formatTime.formatDateTime(searchData.dispatchTime[0]) : '', // 开始时间
                endDate: searchData.dispatchTime ? formatTime.formatDateTime(searchData.dispatchTime[1]) : '', // 结束时间
                orderBy: 'dispatchTime',
                ...val,
                ...this.trafficListsPage
            };
            params['carrierVisibleFlag'] = 'Y';
            params['carrierCode'] = this.supplier.supplierCode;
            const startTime = params.beginDate || 0;
            const endTime = params.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!params.dispatchNo && !startTime) {
                return this.$message.warning('发车单号 和 开始时间 不可同时为空');
            } else if (!params.dispatchNo && startTime) {
                if (timeDifference > 90 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过90天！');
                }
            }
            this.$refs.search.changeLoading(true);
            this.mianLoading = true;
            getTrafficLists(params).then(res => {
                this.$refs.search.changeLoading(false);
                this.mianLoading = false;
                if (res && res.data) {
                    this.tabOneArrs = [];
                    this.tabTwoArrs = [];
                    var scrollArr = [];
                    const data = res.data;
                    this.trafficListsPage.total = data.pagingData.totalCount;
                    this.ontheway = data.ontheway;
                    this.overdue = data.overdue;
                    scrollArr = data.pagingData.list.map((item, index) => {
                        item.icon = require('@/assets/cheliang.png');
                        item.rate = '装载率';
                        item.vehicleCard = data.pagingData.list[index].vehicleCard; // 车牌号
                        item.className = (data.pagingData.list[index].loadRate * 100) >= 80 ? 'fontGreenColor' : 'fontRedColor';
                        item.efficiency = `${(data.pagingData.list[index].loadRate * 100).toFixed(2)}` + '%'; // 百分比
                        if (item.typeFlag === '1') {
                            this.tabOneArrs.push(item);
                        } else if (item.typeFlag === '2') {
                            this.tabTwoArrs.push(item);
                        } else if (item.typeFlag === '1,2') {
                            this.tabOneArrs.push(item);
                            this.tabTwoArrs.push(item);
                        }
                        return item;
                    });
                    if (type) {
                        this.tabItems.push.apply(this.tabItems, scrollArr);
                    } else {
                        this.tabItems = scrollArr;
                    }
                }
            }).catch(() => {
                this.$refs.search.changeLoading(false);
                this.mianLoading = false;
            });
        },
        // 查询行车轨迹(地图)
        loadGetSearchChange (item) {
            this.mianLoading = true;
            this.morePoints = [];
            this.cardMorePoints = [];
            this.baoMorePoints = [];
            this.g7MorePoints = [];
            this.weiMorePoints = [];
            let transportStartPointsByTime = [];
            let transportEndPointsByTime = [];
            const transportEndPointsNoTime = [];
            const transportStartPointsNoTime = [];
            this.polylinePath = [];
            this.clickPointArr = [];
            this.clickPointArrPath = [];
            const params = {
                dispatchNo: this.$route.params.dispatchNo ? this.$route.params.dispatchNo : item.dispatchNo,
                task: '',
                type: '20'
            };
            getTrajectoryLists(params).then(res => {
                this.mianLoading = false;
                res.data.transportList.map(item => {
                    if (item.actualArriveDate) {
                        transportStartPointsByTime.push({
                            id: item.id + '装',
                            time: item.actualArriveDate,
                            icon: require('@/assets/gj_zhuang.png'),
                            geo: { lng: item.startLng, lat: item.startLat },
                            indexId: item.id,
                            pointType: 'zhuang'
                        });
                    } else if (item.loadDate) {
                        transportStartPointsByTime.push({
                            id: item.id + '装',
                            time: item.loadDate,
                            icon: require('@/assets/gj_zhuang.png'),
                            geo: { lng: item.startLng, lat: item.startLat },
                            indexId: item.id,
                            pointType: 'zhuang'
                        });
                    } else {
                        transportStartPointsNoTime.push({
                            id: item.id + '装',
                            icon: require('@/assets/gj_zhuang.png'),
                            geo: { lng: item.startLng, lat: item.startLat },
                            indexId: item.id,
                            pointType: 'zhuang'
                        });
                    }
                    if (item.arrivalTime) {
                        transportEndPointsByTime.push({
                            id: item.id + '卸',
                            time: item.arrivalTime,
                            icon: require('@/assets/gj_xie.png'),
                            geo: { lng: item.endLng, lat: item.endLat },
                            indexId: item.id,
                            pointType: 'xie'
                        });
                    } else if (item.electronicTime) {
                        transportEndPointsByTime.push({
                            id: item.id + '卸',
                            time: item.electronicTime,
                            icon: require('@/assets/gj_xie.png'),
                            geo: { lng: item.endLng, lat: item.endLat },
                            indexId: item.id,
                            pointType: 'xie'
                        });
                    } else {
                        transportEndPointsNoTime.push({
                            id: item.id + '卸',
                            icon: require('@/assets/gj_xie.png'),
                            geo: { lng: item.endLng, lat: item.endLat },
                            indexId: item.id,
                            pointType: 'xie'
                        });
                    }
                });
                res.data.pointList.map(item => {
                    if (+item.trackingSource === 1) {
                        this.morePoints.push({
                            id: item.id + '直',
                            icon: require('@/assets/gj_ztbao.png'),
                            trackingSource: item.trackingSource,
                            geo: { lng: item.longitude, lat: item.latitude },
                            indexId: item.id,
                            pointType: 'other'
                        });
                    } else if (+item.trackingSource === 2) {
                        this.morePoints.push({
                            id: item.id + '微',
                            icon: require('@/assets/gj_wechat.png'),
                            trackingSource: item.trackingSource,
                            geo: { lng: item.longitude, lat: item.latitude },
                            indexId: item.id,
                            pointType: 'other'
                        });
                    } else if (+item.trackingSource === 3) {
                        this.morePoints.push({
                            id: item.id + '卡',
                            icon: require('@/assets/gj_xhka.png'),
                            trackingSource: item.trackingSource,
                            geo: { lng: item.longitude, lat: item.latitude },
                            indexId: item.id,
                            pointType: 'other'
                        });
                    } else if (+item.trackingSource === 4) {
                        this.morePoints.push({
                            id: item.id + 'G7',
                            icon: require('@/assets/gj_g7.png'),
                            trackingSource: item.trackingSource,
                            geo: { lng: item.longitude, lat: item.latitude },
                            indexId: item.id,
                            pointType: 'other'
                        });
                    }
                });
                transportStartPointsByTime = transportStartPointsByTime.sort(function(a, b) {
                    return a.time > b.time ? 1 : -1;
                });
                transportEndPointsByTime = transportEndPointsByTime.sort(function(a, b) {
                    return a.time > b.time ? 1 : -1;
                });
                this.points = transportStartPointsByTime.concat(transportStartPointsNoTime).concat(transportEndPointsByTime).concat(transportEndPointsNoTime);
                this.polylinePoint = transportStartPointsByTime.concat(transportEndPointsByTime);
                this.polylinePoint.forEach(item => {
                    this.polylinePath.push(item.geo);
                });
                this.initMap();
            }).catch(() => {
                this.mianLoading = false;
            });
        },
        // 查询
        searchChange(data) {
            if (data.dispatchTime !== null && data.dispatchTime !== '') {
                data.beginDate = formatTime.formatDateTime(data.dispatchTime[0]); // 发车时间
                data.endDate = formatTime.formatDateTime(data.dispatchTime[1]);
            } else {
                data.beginDate = ''; // 开始时间
                data.endDate = ''; // 结束时间
            }
            // data.dispatchStatus = 40;
            this.current = '';
            this.isShow = false;
            this.load(data);
        },
        // 点击左边每一项查询地图站点信息
        tabClick(item, index) {
            this.currentItem = item;
            this.current = index;
            this.isShow = true;
            this.loadGetSearchChange(item);
        },
        // 在途 逾期
        contentTitleClick(indexValue) {
            this.current = '';
            this.isShow = false;
            this.currentIdx = indexValue;
            this.tabItems = indexValue === 1 ? this.tabOneArrs : this.tabTwoArrs;
        },
        handleScroll(event) {
            // let target = event.target;
            // if (target.scrollTop && (Math.ceil(target.scrollTop) + target.clientHeight) >= target.scrollHeight) {
            //     if (this.tabItems.length < this.trafficListsPage.total) {
            //         this.trafficListsPage.pageNo++;
            //         this.load({}, true);
            //     }
            // }
        },
        initMap() {
            loadBMap().then((BMap) => {
                this.BMap = BMap[0];
                this.BMapLib = BMap[1];
                this.myMap = new BMap[0].Map(this.mapId);
                this.BMapLib.LuShu.prototype._move = function (initPos, targetPos, effect) {
                    var pointsArr = [initPos, targetPos];
                    const me = this;
                    let currentCount = 0;
                    const timer = 10;
                    const step = this._opts.speed / (1000 / timer);
                    const initpos = this._projection.lngLatToPoint(initPos);
                    const targetpos = this._projection.lngLatToPoint(targetPos);
                    const count = Math.round(me._getDistance(initpos, targetpos) / step);
                    this._map.addOverlay(new BMap[0].Polyline(pointsArr, {
                        strokeColor: '#5EB0DC',
                        strokeWeight: 5,
                        strokeOpacity: 0.5
                    }));
                    if (count < 1) {
                        me._moveNext(++me.i);
                        return;
                    }
                    me._intervalFlag = setInterval(function() {
                        if (currentCount >= count) {
                            clearInterval(me._intervalFlag);
                            if (me.i > me._path.length) {
                                return;
                            }
                            me._moveNext(++me.i);
                        } else {
                            currentCount++;
                            const x = effect(initpos.x, targetpos.x, currentCount, count);
                            const y = effect(initpos.y, targetpos.y, currentCount, count);
                            const pos = me._projection.pointToLngLat(new BMap[0].Pixel(x, y));
                            if (currentCount === 1) {
                                var proPos = null;
                                if (me.i - 1 >= 0) {
                                    proPos = me._path[me.i - 1];
                                }
                                if (me._opts.enableRotation === true) {
                                    me.setRotation(proPos, initPos, targetPos);
                                }
                                if (me._opts.autoView) {
                                    if (!me._map.getBounds().containsPoint(pos)) {
                                        me._map.setCenter(pos);
                                    }
                                }
                            }
                            me._marker.setPosition(pos);
                            me._setInfoWin(pos);
                        }
                    }, timer);
                };
                if (this.points.length > 0) {
                    this.myMap.centerAndZoom(new BMap[0].Point(this.points[0].geo.lng, this.points[0].geo.lat), 12);
                } else {
                    this.myMap.centerAndZoom(new BMap[0].Point(113.216596, 22.913121), 12);
                }
                this.myMap.enableScrollWheelZoom(true);
                const navigationControl = new BMap[0].NavigationControl({
                    anchor: 'BMAP_ANCHOR_TOP_LEFT',
                    type: 'BMAP_NAVIGATION_CONTROL_LARGE'
                });
                this.myMap.addControl(navigationControl);
                this.myMap.setMapStyle({
                    features: ['road', 'building', 'water', 'land'],
                    style: 'grayscale'
                });
                this.morePoints = this.morePoints.filter(item => +item.geo.lat > 3.55 && +item.geo.lat < 53 && +item.geo.lng > 73.3 && +item.geo.lng < 135);
                this.addSelfMarker(this.points);
                this.g7MorePoints = this.morePoints.filter(item => item.trackingSource === '4');
                this.baoMorePoints = this.morePoints.filter(item => item.trackingSource === '1');
                this.weiMorePoints = this.morePoints.filter(item => item.trackingSource === '2');
                this.cardMorePoints = this.morePoints.filter(item => item.trackingSource === '3');
                if (this.cardMorePoints.length > 0) {
                    this.initPointsShow('3', '小黑卡', this.cardMorePoints, 'blue');
                } else if (this.baoMorePoints.length > 0) {
                    this.initPointsShow('1', '直通宝', this.baoMorePoints, 'red');
                } else if (this.weiMorePoints.length > 0) {
                    this.initPointsShow('2', '微信', this.weiMorePoints, '#cfb762');
                } else if (this.g7MorePoints.length > 0) {
                    this.initPointsShow('4', 'G7', this.g7MorePoints, 'green');
                } else {
                    this.trackClassify = '';
                    this.trackClassifyName = '';
                }
                this.initLushu(this.morePoints);
            });
        },
        initPointsShow(trackClassify, trackClassifyName, points, lineColor = '#18a45b', name) {
            this.trackClassify = trackClassify;
            this.trackClassifyName = trackClassifyName;
            this.addSelfMarker(points);
            if (points && points.length > 1) this.addPolyLine(points, lineColor);
        },
        addInfoContent(item, marker) {
            marker.addEventListener('mouseover', (e) => {
                const params = { id: item.indexId };
                if (item.pointType === 'other') {
                    pointList(params).then(res => {
                        if (res) {
                            let infoContent = '';
                            const resData = res.data.list.length > 0 ? res.data.list[0] : {};
                            const trackingSource = {
                                1: '直通宝',
                                2: '微信',
                                3: '小黑卡',
                                4: 'G7'
                            };
                            resData.trackingSource = trackingSource[resData.trackingSource] || resData.trackingSource;
                            if (item.pointType === 'other') {
                                infoContent = `<ul>
                                    <li>设备类型：${resData.trackingSource || ''}</li>
                                    <li>定位人：${resData.createUserName || ''}</li>
                                    <li>定位时间：${resData.trackingDate || ''}</li>
                                    <li>定位地点：${resData.trackingLocationName || ''}</li>
                                    <li>定位经度：${resData.longitude || ''}</li>
                                    <li>定位纬度：${resData.latitude || ''}</li>
                                </ul>`;
                            }
                            this.openInfo(infoContent, e);
                        }
                    });
                } else {
                    const infoContent = `<ul>
                        <li>经度：${item.geo.lng || ''}</li>
                        <li>纬度：${item.geo.lat || ''}</li>
                    </ul>`;
                    this.openInfo(infoContent, e);
                }
            });
            marker.addEventListener('mouseout', (e) => {
                // this.myMap.closeInfoWindow();
            });
            marker.addEventListener('click', (e) => {
                const getOverlays = this.myMap.getOverlays();
                getOverlays.forEach(item => {
                    if (item.name === 'clearLine') {
                        this.myMap.removeOverlay(item);
                    }
                });
                this.clickPointArrPath = [];
                this.clickPointArr.push(item);
                if (this.clickPointArr.length > 2) {
                    this.clickPointArr.shift();
                }
                this.clickPointArr.forEach(point => {
                    this.clickPointArrPath.push(point);
                });
                if (this.clickPointArrPath.length >= 2) {
                    const pointA = new this.BMap.Point(this.clickPointArrPath[0].geo.lng, this.clickPointArrPath[0].geo.lat);
                    const pointB = new this.BMap.Point(this.clickPointArrPath[1].geo.lng, this.clickPointArrPath[1].geo.lat);
                    this.distance = (this.myMap.getDistance(pointA, pointB) / 1000).toFixed(2);
                    this.addPolyLine(this.clickPointArrPath, '#0087d2', false, true);
                    const lng = (+this.clickPointArrPath[0].geo.lng + (+this.clickPointArrPath[1].geo.lng)) / 2;
                    const lat = (+this.clickPointArrPath[0].geo.lat + (+this.clickPointArrPath[1].geo.lat)) / 2;
                    const position = new this.BMap.Point(lng, lat);
                    const opts = {
                        position: position
                    };
                    const label = new this.BMap.Label(`${this.distance}KM`, opts);
                    label.setStyle({
                        color: 'red',
                        fontSize: '20px',
                        height: '24px',
                        lineHeight: '24px'
                    });
                    label.name = 'clearLine';
                    this.myMap.addOverlay(label);
                }
            });
        },
        openInfo(infoContent, e) {
            var p = e.target;
            var point = new this.BMap.Point(p.getPosition().lng, p.getPosition().lat);
            var infoWindow = new this.BMap.InfoWindow(infoContent, this.opts);
            this.myMap.openInfoWindow(infoWindow, point);
        },
        initLushu(morePoints) {
            const landmarkPois = [];
            morePoints.forEach(item => {
                var point = new this.BMap.Point(item.geo.lng, item.geo.lat);
                landmarkPois.push(point);
            });
            this.lushu = new this.BMapLib.LuShu(this.myMap, landmarkPois, {
                autoView: true,
                icon: new this.BMap.Icon(require('@/assets/track_car.png'), new this.BMap.Size(55, 22), { anchor: new this.BMap.Size(27, 13) }),
                speed: this.trackSpeed,
                enableRotation: true, // 是否设置marker随着道路的走向进行旋转
                landmarkPois: []
            });
        },
        addSelfMarker(points) {
            points.forEach(item => {
                var pt = new this.BMap.Point(item.geo.lng, item.geo.lat);
                var myIcon = new this.BMap.Icon(item.icon, new this.BMap.Size(28, 50));
                var marker2 = new this.BMap.Marker(pt, { icon: myIcon });
                this.myMap.addOverlay(marker2);
                this.addInfoContent(item, marker2);
            });
        },
        addPolyLine(points, lineColor = '#18a45b', iconsShow = true, clearLine = false) {
            const pois = [];
            points.forEach(item => {
                pois.push(new this.BMap.Point(item.geo.lng, item.geo.lat));
            });
            // eslint-disable-next-line
            var sy = new this.BMap.Symbol(BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW, {
                scale: 0.6,
                strokeColor: '#fff',
                strokeWeight: '1'
            });
            var icons = new this.BMap.IconSequence(sy, '10', '30');
            var polyline = new this.BMap.Polyline(pois, {
                enableEditing: false,
                enableClicking: true,
                icons: iconsShow ? [icons] : [],
                strokeWeight: '4',
                strokeOpacity: 0.8,
                strokeColor: lineColor
            });
            if (clearLine) polyline.name = 'clearLine';
            this.myMap.addOverlay(polyline);
        },
        trackPlayback() {
            let trackClassifyPoints = [];
            if (this.morePoints.length <= 0) return this.$message.warning('没有可回放的轨迹');
            if (!this.trackClassify) {
                return this.$message.warning('请选择要回放的轨迹类别');
            } else {
                trackClassifyPoints = this.morePoints.filter(item => item.trackingSource === this.trackClassify);
                if (trackClassifyPoints.length <= 0) return this.$message.warning(`没有可回放的 ${this.trackClassifyName} 轨迹`);
                this.myMap.clearOverlays();
                this.addSelfMarker(trackClassifyPoints);
                this.addPolyLine(trackClassifyPoints);
                this.initLushu(trackClassifyPoints);
            }
            this.lushu.stop();
            this.lushu.start();
            this.myMap.centerAndZoom(new this.BMap.Point(this.morePoints[0].geo.lng, this.morePoints[0].geo.lat), 12);
        },
        handleSpeedClick(index) {
            if (index === '5') {
                this.handleNum = '快';
            } else if (index === '3') {
                this.handleNum = '正常';
            } else if (index === '1') {
                this.handleNum = '慢';
            }
            this.trackSpeed = 1000 * index;
            if (this.lushu._opts) this.lushu._opts.speed = this.trackSpeed;
        },
        trackStop() {
            this.trackState = 2;
            this.lushu.pause();
        },
        trackBegin() {
            if (this.morePoints.length <= 0) return this.$message.warning('没有可播放的轨迹');
            if (!this.trackClassify) {
                return this.$message.warning('请选择要播放的轨迹类别');
            } else {
                if (+this.trackState === 0) {
                    this.trackState = 1;
                    const trackClassifyPoints = this.morePoints.filter(item => item.trackingSource === this.trackClassify);
                    if (trackClassifyPoints.length <= 0) return this.$message.warning(`没有可播放的 ${this.trackClassifyName} 轨迹`);
                    this.myMap.clearOverlays();
                    this.addSelfMarker(trackClassifyPoints);
                    this.addPolyLine(trackClassifyPoints);
                    this.initLushu(trackClassifyPoints);
                    this.trackPlayback();
                } else {
                    this.trackState = 1;
                    this.lushu.start();
                }
            }
        },
        handlePointList() {
            this.isPointListShow = true;
        },
        handleTrackClassify(index) {
            this.myMap.clearOverlays();
            this.addSelfMarker(this.points);
            if (index === '1') {
                this.initPointsShow('1', '直通宝', this.baoMorePoints, 'red');
            } else if (index === '2') {
                this.initPointsShow('2', '微信', this.weiMorePoints, '#cfb762');
            } else if (index === '3') {
                this.initPointsShow('3', '小黑卡', this.cardMorePoints, 'blue');
            } else if (index === '4') {
                this.initPointsShow('4', 'G7', this.g7MorePoints, 'green');
            }
        },
        mapInit() {
            loadMap().then(BMap => {
                this.myMap = new BMap.Map(this.mapId);
                this.myMap.centerAndZoom(new BMap.Point(113.216596, 22.913121), 15);
                this.myMap.enableScrollWheelZoom(true);
                var navigationControl = new BMap.NavigationControl({
                    anchor: 'BMAP_ANCHOR_TOP_LEFT',
                    type: 'BMAP_NAVIGATION_CONTROL_LARGE'
                });
                this.myMap.addControl(navigationControl);
            });
        },
        pointListClose() {
            this.isPointListShow = false;
        }
    },
    mounted() {
        this.$refs.search.searchData.dispatchNo = this.$route.params.dispatchNo;
        // this.load();
        this.mapInit();
    },
    beforeRouteEnter (to, from, next) {
        if (from.path === '/dispatch-order' || from.path === '/order-manage/task-detail' || from.path === '/dispatch-order/dispatch-order-detail' ||
            from.path === '/distribute/vehicle-management') {
            next(vm => {
                if (vm.$route.params.dispatchNo) {
                    vm.$refs.search.searchData.dispatchNo = vm.$route.params.dispatchNo;
                    vm.$refs.search.searchData.dispatchTime = '';
                    vm.load();
                }
            });
        } else {
            next();
        }
    },
    watch: {
        isShow(val) {
            if (!val) this.myMap.clearOverlays();
        }
    }
};
</script>
<style lang='less'>
@import "./trafficTrajectory.less";
</style>